import { render } from "./Console.vue?vue&type=template&id=420b2e10&ts=true"
import script from "./Console.vue?vue&type=script&lang=ts"
export * from "./Console.vue?vue&type=script&lang=ts"

import "./Console.vue?vue&type=style&index=0&id=420b2e10&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__